// extracted by mini-css-extract-plugin
module.exports = {"main":"Pitch_main__335lD","scoreBoard":"Pitch_scoreBoard__3FsKW","team":"Pitch_team__2nWJB","result":"Pitch_result__1R5Ft"};